import { toBlob } from "html-to-image";
import { toast } from "sonner";

export async function shareNodeAsImage(node, { filename, title, text }) {
    try {
        const bg = getComputedStyle(document.body).backgroundColor;
        const blob = await toBlob(node, { pixelRatio: 2, backgroundColor: bg });
        const file = new File([blob], filename, { type: "image/png" });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title, text });
            return;
        }
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
        toast.success("Afbeelding gedownload — stuur hem door in WhatsApp");
    } catch (e) {
        if (e?.name !== "AbortError") toast.error("Kon afbeelding niet maken");
    }
}
